import { LocationGroupsComponent } from './lib/location-groups.component';
export default LocationGroupsComponent;
